<div *ngIf="DontShow == false" class="loading-screen text-center" role="status" aria-label="Loading Church Services">
    <div class="church-loader" aria-hidden="true">
        <span class="church-loader__ring"></span>
        <span class="church-loader__accent"></span>
        <img *ngIf="logoSource" class="church-loader__logo" [src]="logoSource" alt="" (error)="onLogoError()" />
        <span *ngIf="!logoSource" class="church-loader__fallback">✝</span>
    </div>
    <div class="loading-screen__message">
        <span *ngIf="globalService.resourceArr.length > 0" [class.SmallArabicFont]="globalService.isRTL == true">{{ globalService.resourceArr == null || globalService.resourceArr.length == 0? 'Waited long?' : globalService.Get("WAITED_LONG?") }}</span>
        <br><br>
        <button type="button" class="btn btn-primary" data-toggle="button" (click)="GoHome()" aria-pressed="false"
            autocomplete="off" [class.SmallArabicFont]="globalService.isRTL == true">
            {{ globalService.resourceArr == null || globalService.resourceArr.length == 0? 'Click here' :globalService.Get("CLICK_HERE") }}
        </button>
    </div>
</div>
